<!-- <p-toast [style]="{marginTop: '80px'}"></p-toast> -->
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}


<div class="p-p-4">
  <form [formGroup]="form1">
    <p-fieldset styleClass="p-fluid" [toggleable]="false">
      <div class="p-fluid p-formgrid p-grid">
        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-4">
            @if (proformaList?.length > 0) {
              <p-dropdown [options]="proformaList"
                formControlName="proformaId" optionLabel="customOption" appendTo="body"
                optionValue="proformaId" (onChange)="onSelectProforma($event)"
                [filter]="true" filterBy="name" [showClear]="false"
                placeholder="Copy Proforma From">
              </p-dropdown>
            }
            <label for="Copy Proforma From">Copy Proforma From</label>
            <span>
              @if (proformaNotSelected) {
                <small class="p-invalid"
                  >Please Select Proforma to be copied.
                </small>
              }
            </span>
          </span>
          <!-- Existing Proforma dropdown stays as is -->

          <!-- New Property Lead Profile dropdown -->
          @if (propertyLeadProfileList?.length > 0) {
            <span class="p-float-label required-field w-100 mb-4">
              @if (propertyLeadProfileList?.length > 0) {
                <p-dropdown
                  [options]="propertyLeadProfileList"
                  formControlName="propertyLeadProfileId"
                  optionLabel="customOption"
                  optionValue="propertyLeadProfileId"
                  appendTo="body"
                  (onChange)="onSelectPropertyLeadProfile($event)"
                  [filter]="true"
                  filterBy="customOption"
                  [showClear]="false"
                  placeholder="Select Property Lead Profile">
                </p-dropdown>
              }
              <label for="propertyLeadProfileId">Property Lead Profile</label>
              <span>
                @if (profileNotSelected) {
                  <small class="p-invalid">
                    Please select property lead profile.
                  </small>
                }
              </span>
            </span>
          }

        </div>
        <div class="p-d-flex p-jc-end p-mt-4">
          @if (formErrorMessage) {
            <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
          }
          <br>
            @if (!ownerLeadProfileId) {
              <button pButton type="button" label="Copy" (click)="onFormSubmit()"></button>
            }
            @if (ownerLeadProfileId) {
              <button pButton type="button" label="Copy" (click)="onCopyForOwnerLead()"></button>
            }
          </div>
        </div>
      </p-fieldset>
    </form>
  </div>
